module.exports = __webpack_public_path__ + "static/media/x-icon.92c1601e.svg";